import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { toast } from 'sonner';

import { BILLING_LIST_PERMISSION } from '&/features/billing/paths';
import i18n from '&/i18n/config';

// The Billing area (SWOOP-430). One guard for every Billing page beneath it; each child supplies its own page
// shell, so this layout only renders the Outlet. Deliberately NO module gate — Billing is not a module surface.
export const Route = createFileRoute('/_authenticated/billing')({
  beforeLoad: ({ context }): void => {
    // Permission gate: a user without `billing:list` goes back to the Dashboard and is told why (the AC asks for a
    // message). This covers navigation once permissions are known; on a hard refresh they are not yet, the load
    // goes through, and BillingPageLayout re-checks and announces the same message.
    if (context.permissions.isReady && !context.permissions.hasPermission(BILLING_LIST_PERMISSION)) {
      toast.error(i18n.t('pages.billing.accessDenied'));
      throw redirect({ replace: true, to: '/' });
    }
  },
  component: Outlet,
});
